import React, { useState } from 'react';
import CustomInput from '../../../components/input/CustomInput';
import { Controller, useForm } from 'react-hook-form';
import yup from '../../../libs/yup/yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { rejectTenantRequest } from '../../../api/sportaloka-client';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';

const defaultValues = {
  notes: ''
};

const schema = yup.object().shape({
  notes: yup.string().label('Alasan Penolakan').required('${label} wajib diisi')
});

function RejectTenantModal({ onFetchData }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { id } = useParams();

  const {
    control,
    handleSubmit,
    formState: { errors }
  } = useForm({
    defaultValues,
    mode: 'onChange',
    resolver: yupResolver(schema)
  });

  const onSubmit = async (val) => {
    Swal.fire({
      title: 'Apakah anda yakin?',
      text: 'Kami akan mengirimkan email ke owner beserta alasannya. owner dapat melakukan registrasi kembali diaplikasi,',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Lanjutkan!',
      cancelButtonText: 'Batalkan'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setLoading(true);
          await rejectTenantRequest(id, val.notes);
          document.getElementById('closeModal').click();
          Swal.fire({
            title: 'Berhasil!',
            text: `Berhasil mengubah status permintaan tenant`,
            icon: 'success',
            confirmButtonText: 'Tutup'
          });
          navigate('/tenants');
          onFetchData();
          setLoading(false);
        } catch (error) {
          setLoading(false);
          Swal.fire({
            title: 'Gagal!',
            text: 'Periksa koneksi anda dan coba kembali.',
            icon: 'error',
            confirmButtonText: 'Tutup'
          });
        }
      }
    });
  };

  return (
    <div className="modal" tabIndex="-1" id="exampleModal">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Reject Form</h5>
            <button
              id="closeModal"
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              <Controller
                control={control}
                name="notes"
                render={({ field: { onChange, onBlur, value } }) => (
                  <div className="col-12">
                    <CustomInput
                      onChange={onChange}
                      onBlur={onBlur}
                      value={value}
                      type="text"
                      label="Alasan Penolakan"
                      isError={Boolean(errors.notes)}
                      errorMessage={Boolean(errors.notes) && errors.notes.message}
                    />
                  </div>
                )}
              />
              <button
                disabled={loading}
                type="submit"
                className="button py-15 mt-20 -dark-1 bg-blue-1 text-white w-100">
                {loading ? 'Mohon tunggu...' : 'Tolak Permintaan'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RejectTenantModal;
